import styled from "styled-components";

export const LoginWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  & > div {
    width: 100%;
    max-width: 93.9rem;
    min-height: 46.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5.4rem;

    section:nth-child(1) {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      max-width: 44.4rem;
      max-height: 46.1rem;
      border: 0.2rem solid var(--color-grey-0);
      padding: 2.4rem 2.6rem;
      gap: 1.9rem;
      & > div {
        max-width: 32.7rem;
        width: 100%;
        height: 3.6rem;
        text-align: center;
        line-height: 150%;
      }
    }
    section:nth-child(2) {
      display: flex;
      flex-direction: column;
    }
  }
  @media (max-width: 768px) {
    & > div {
      margin-top: 10rem;
      flex-direction: column-reverse;
      align-items: center;
      justify-content: center;
      gap: 1.4rem;
      max-width: 37.7rem;
      width: 100%;
      padding: 2rem;

      & > :nth-child(1) {
        max-width: 32rem !important;
        width: 100% !important;
      }
    }
  }
`;
